import { createSelector } from 'reselect';
import { getSlice } from './deviations';

export const getStatusUpdateError = createSelector(
  getSlice,
  slice => slice.statusEdit?.error ?? ''
);
export const getIsStatusSubmitting = createSelector(
  getSlice,
  slice => slice.statusEdit?.isSubmitting ?? false
);
